import { render, staticRenderFns } from "./_Routes.vue?vue&type=template&id=6ba39ca8&"
import script from "./_Routes.vue?vue&type=script&lang=js&"
export * from "./_Routes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports